// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"273":"aec46c9e","910":"b039f72b"}[chunkId] + ".chunk.css";
};